
import LoadingLogo from './BrandLogo.vue'
export default {
  name: 'LoadingComponent',
  components: { LoadingLogo }
}
